// extracted by mini-css-extract-plugin
export var banner = "_21-0";
export var icon = "_21-1";
export var message = "_21-2";